import * as React from 'react';
import * as classNames from 'classnames';
import * as globalStyles from 'styles/style.scss';
import * as styles from './styles.scss';
import { Fallback } from 'components/common';
import { IState } from 'redux/global-reducers';
import { SymbolType } from 'constants/enum';
import { WithNamespaces, withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { domainConfig } from 'config/domain';
import { formatNumber, handleError } from 'utils/common';
import { priceFormatted } from 'utils/board';
import { withErrorBoundary } from 'react-error-boundary';
import config from 'config';

interface ICurrentPriceFieldProps
  extends React.ClassAttributes<CurrentPriceFieldComponent>,
    WithNamespaces {
  readonly currentSymbol: IState['currentSymbol'];
  readonly currentSymbolData: IState['currentSymbolData'];

  readonly onClickPrice: (price?: number) => void;
}

class CurrentPriceFieldComponent extends React.Component<
  ICurrentPriceFieldProps
> {
  constructor(props: ICurrentPriceFieldProps) {
    super(props);
  }

  render() {
    const { t, currentSymbolData } = this.props;
    const isBondSymbol =
      this.props.currentSymbol.infoData?.t === SymbolType.BOND &&
      domainConfig[config.domain]?.hideCeilingFloorInFuturesBond;
    return currentSymbolData ? (
      <div
        className={`${styles.CurrentPriceField} ${
          isBondSymbol ? '' : styles.SpaceBetween
        }`}
      >
        <div
          className={classNames(
            'text-nowrap',
            {
              [globalStyles.Up]:
                currentSymbolData.c &&
                currentSymbolData.re &&
                currentSymbolData.c > currentSymbolData.re,
              [globalStyles.Down]:
                currentSymbolData.c &&
                currentSymbolData.re &&
                currentSymbolData.c < currentSymbolData.re,
              [globalStyles.Ref]:
                currentSymbolData.c &&
                currentSymbolData.re &&
                currentSymbolData.c === currentSymbolData.re,
              [globalStyles.Ceil]: currentSymbolData.c === currentSymbolData.ce,
              [globalStyles.Floor]:
                currentSymbolData.c === currentSymbolData.fl,
              [globalStyles.Default]: !currentSymbolData.c,
            },
            styles.PriceInfoLeft
          )}
        >
          <div onClick={this.onClickClosePrice} className={styles.currentPrice}>
            {priceFormatted(currentSymbolData.c, currentSymbolData.t) || 0}
          </div>
          <div>
            <div>{`${formatNumber(
              (currentSymbolData.ch ?? 0) / 1000,
              2
            )}`}</div>
            <div>{`${formatNumber(currentSymbolData.ra, 2)}%`}</div>
          </div>
        </div>
        <div className={styles.PriceInfoRight}>
          <div>
            <div>{`${t('Vol')}`}</div>
            <div
              onClick={this.onClickCeilPrice}
              className={globalStyles.Default}
            >
              {formatNumber(currentSymbolData.vo) ?? '_'}
            </div>
          </div>
          <div>
            <div>{`${t('Ceil')}`}</div>
            <div onClick={this.onClickCeilPrice} className={globalStyles.Ceil}>
              {priceFormatted(currentSymbolData.ce, currentSymbolData.t) || 0}
            </div>
          </div>
          <div>
            <div>{`${t('Floor')}`}</div>
            <div
              onClick={this.onClickFloorPrice}
              className={globalStyles.Floor}
            >
              {priceFormatted(currentSymbolData.fl, currentSymbolData.t) || 0}
            </div>
          </div>
          <div>
            <div>{`${t('Ref')}`}</div>
            <div onClick={this.onClickRefPrice} className={globalStyles.Ref}>
              {priceFormatted(currentSymbolData.re, currentSymbolData.t) || 0}
            </div>
          </div>
        </div>
      </div>
    ) : null;
  }

  private onClickClosePrice = () => {
    this.props.onClickPrice(this.props.currentSymbolData?.c);
  };

  private onClickRefPrice = () => {
    this.props.onClickPrice(this.props.currentSymbolData?.re);
  };

  private onClickCeilPrice = () => {
    this.props.onClickPrice(this.props.currentSymbolData?.ce);
  };

  private onClickFloorPrice = () => {
    this.props.onClickPrice(this.props.currentSymbolData?.fl);
  };
}

const mapStateToProps = (state: IState) => ({
  currentSymbol: state.currentSymbol,
  currentSymbolData: state.currentSymbolData,
});

const mapDispatchToProps = {};

const CurrentPriceField = withErrorBoundary(
  withNamespaces('common')(
    connect(mapStateToProps, mapDispatchToProps)(CurrentPriceFieldComponent)
  ),
  Fallback,
  handleError
);

export default CurrentPriceField;



// WEBPACK FOOTER //
// ./src/components/common/OrderForm/CurrentPriceField/index.tsx